import {useMutation} from 'react-query';
import {postAuctionSuggest} from 'services/postDetail/auctionSuggest';

const useSetAuctionOffer = (
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const {isLoading, mutate} = useMutation({
    mutationFn: (payload: IPostSuggestionAuction) => {
      return postAuctionSuggest(payload);
    },
    onSuccess: (_, variables) => {
      setIsOpen(false);
    },
  });

  return {isLoading, mutate};
};

export default useSetAuctionOffer;
